import styled, { css } from 'styled-components';
import { getBackgroundColor, getTextColor, themeGet } from '@magalu/stereo-ui-styles';
import Box from '../Box';
import Text from '../Text';
const variations = {
  primary: css`
    background-color: ${props => getBackgroundColor('primary')(props)};
    color: ${props => getTextColor('lightest')(props)};
    font-size: ${props => themeGet('fontSizes.2')(props)}px;
  `,
  secondary: css`
    color: ${props => getTextColor('light')(props)};
  `
};
export const Container = styled.div`
  ${({
  noBorder
}) => !noBorder && css`
      border-bottom: 1px solid #ededed;
    `}
  text-decoration: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 4px 12px 12px;
  ${props => variations[props.variation]}
`;
export const ContainerBox = styled(Box)`
  flex: 1;
`;
export const TextMenu = styled(Text).attrs(({
  isLink,
  chevronRight
}) => ({
  fontSize: 1,
  fontWeight: isLink || !chevronRight ? 'regular' : 'medium'
}))`
  ${props => variations[props.variation]}
  line-height: ${props => themeGet('lineHeights.tall')(props)}px;
  padding-left: ${props => props.icon ? '8px' : '0px'};
`;